import React from 'react';
import { BsChevronDown, BsChevronExpand, BsChevronUp } from 'react-icons/bs';
import { Icon } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const SortIcon = ({ column }) => {
  if (column.disableSortBy) return null;
  let icon = BsChevronExpand;
  if (column.isSorted) {
    icon = column.isSortedDesc ? BsChevronDown : BsChevronUp;
  }

  return <Icon as={icon} ml={1} />;
};

SortIcon.propTypes = {
  column: PropTypes.shape({
    disableSortBy: PropTypes.bool,
    isSorted: PropTypes.bool,
    isSortedDesc: PropTypes.bool
  })
};

export default SortIcon;
